cafm.browsers = {

    bbMobileClass: 'BBMobile',
    chromeClass: 'Chrome',
    chromeMobileClass: 'ChromeMobile',
    edgeClass: 'Edge',
    edgeMobileClass: 'EdgeMobile',
    firefoxClass: 'Firefox',
    ieClass: 'IE',
    ieMobileClass: 'IEMobile',
    desktopClass: 'desktop',
    mobileClass: 'mobile',
    safariClass: 'Safari',
    touchClass: 'touch',
    iosClass: 'ios',
    supportsInput: function(t){

        var i = document.createElement("input");
        i.setAttribute('type', t);
        return i.type !== 'text';
    },
    isMobileOnDesktop: function() {

        return body.hasClass(cafm.browsers.desktopClass) && body.hasClass(cafm.browsers.mobileClass);
    },
    isTouchAble: function () {
        return cafm.browsers.isStandardTouchAble() || cafm.browsers.isIeMobileTouchAble();
    },
    isStandardTouchAble: function () {
        return isDefined(document.documentElement['ontouchstart']);
    },
    isMouseAble: function () {
        return isDefined(document.documentElement['mouseup']);
    },
    isIeMobileTouchAble: function () {

        return window.navigator['msPointerEnabled'] && window.navigator["msMaxTouchPoints"] > 0;
    },
    setIsTouchAble: function (ist) {
        
        if(ist === true){
            body.addClass(cafm.browsers.touchClass);
        }
        else{
                
            body.removeClass(cafm.browsers.touchClass);
        }

        isTouch = ist;
    },
    isSafari: function () {

        return body.hasClass(this.safariClass);
    },
    isIe: function () {

        return body.hasClass(this.ieClass);
    },
    isIe9Or10: function () {

        return body.hasClass('IE9') || body.hasClass('IE10');
    },
    isIeMobile: function () {

        return body.hasClass(this.ieMobileClass);
    },
    isBbMobile: function () {

        return body.hasClass(this.bbMobileClass);
    },
    isEdge: function() {

        return body.hasClass(this.edgeClass);
    },
    isEdgeMobile: function () {

        return body.hasClass(this.edgeMobileClass);
    },
    isChrome: function () {

        return body.hasClass(this.chromeClass);
    },
    isChromeMobile: function () {

        return body.hasClass(this.chromeMobileClass);
    },
    isFirefox: function () {

        return body.hasClass(this.firefoxClass);
    },
    isIos() {
        return body.hasClass(this.iosClass);
    }
}